module.exports = __webpack_public_path__ + "static/media/Residential_39.1dd9a831.jpg";